/* eslint-disable consistent-return */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Device } from '@beef/smart-kit';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames/bind';

import {
  addToBasketCrossSell,
  setCrossSellActiveId,
} from 'store/ProductDetails/crossSellProducts/actions';
import { SOURCES } from 'store/common/basket/constants';
import { getIsItemInBasket } from 'store/common/basket/selectors';
import { deviceButtonTitle, deviceVariant } from 'constants/device';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getBadges = (badges) => {
  if (badges) {
    return badges.map((badge) => ({
      children: badge.title,
      help: badge.content,
      variant: badge.variant,
      textColor: badge.textColor,
    }));
  }
};

const getDiscount = (price, oldPrice) => {
  if (oldPrice) {
    return Math.floor(((oldPrice - price) * 100) / oldPrice);
  }
};

export const CrossSellTabDevice = ({ product, visibleList }) => {
  const dispatch = useDispatch();
  const discount = getDiscount(product.price.value, product.price?.oldValue);
  const isSamePrice = product.price.value === product.price?.oldValue;

  const device = {
    reviews: {
      count: product.feedback.count,
      average: product.feedback.average,
      link: `shop/details/${product.slug}/otzyvy/`,
    },
    promoBadges: getBadges(product?.badges),
    slug: product.url,
    highlight: product?.highlight || null,
    id: product.productId,
    imgOptions: {
      src: product.imageUrl,
    },
    name: product.title,
    price: product.price.value,
    oldPrice: !isSamePrice && product.price?.oldValue,
    discount: !isSamePrice && discount,
    link: `/shop/details/${product.slug}`,
  };

  // const onOpenModal = onProductClick(product);

  const onProductClick = useCallback(
    (currProduct) => dispatch(setCrossSellActiveId({ productId: currProduct })),
    [dispatch],
  );

  const redirectToBasket = () => {
    window.location.href = '/basket/';
  };

  const onAddDevice = useCallback(
    (id) => {
      const currentProduct = visibleList.find((item) => item.productId === id);
      dispatch(addToBasketCrossSell(currentProduct, SOURCES.SOURCE_NEW_BASKET_RECOMMENDED_PRODUCT));
    },
    [dispatch],
  );

  const isInBasket = useSelector((state) =>
    getIsItemInBasket(state, product.productId?.toString()),
  );

  const purchaseData = {
    variant: isInBasket ? deviceVariant.SECONDARY : deviceVariant.TERTIARY,
    title: isInBasket ? deviceButtonTitle.IN_BASKET : deviceButtonTitle.TO_BASKET,
    onClick: isInBasket ? redirectToBasket : onAddDevice,
  };

  return (
    <Device
      device={device}
      className={cx(device?.highlight && 'left-border')}
      isWithModal
      onOpenModal={onProductClick}
      purchaseData={purchaseData}
    />
  );
};

CrossSellTabDevice.propTypes = {
  product: PropTypes.object,
  basketData: PropTypes.array,
  visibleList: PropTypes.array,
};
